export default "__VITE_ASSET__CuWtQQFV__"